import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { useTracking } from "@similarweb/tracking-provider";
import type { IBreadcrumbs } from "@similarweb/ui-components";
import { Breadcrumbs } from "@similarweb/ui-components";

import { ACTIVATION_HOME_ROUTE, ACTIVATION_PROJECT_ROUTE } from "app/pages/activation/routing/constants";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { useActivationSet } from "../hooks/useActivationSet";
import { useAlertsParams } from "../hooks/useAlertsParams";

export const AlertsBreadcrumbs = () => {
    const { track } = useTracking();
    const { translate } = useTranslate();
    const { activationId } = useAlertsParams();

    const { activationSet, isLoading } = useActivationSet();

    const crumbsList = useMemo(
        () => [
            {
                state: ACTIVATION_HOME_ROUTE,
                title: translate("common.home"),
            },
            {
                state: ACTIVATION_PROJECT_ROUTE,
                title: activationSet?.name ?? "",
                params: {
                    key: activationId,
                    country: activationSet?.country.toString() ?? "",
                    webSource: "",
                },
            },
            {
                state: "",
                title: translate("activation.alerts.page.crumb"),
            },
        ],
        [activationId, activationSet?.name, activationSet?.country, translate],
    );

    const onCrumbClick: IBreadcrumbs["onClick"] = ({ state, params, title }) => {
        track("Breadcrumb", "click", title);

        void proNavigator.go(state, params);
    };

    return (
        <Breadcrumbs
            list={crumbsList}
            isLoading={isLoading}
            onClick={onCrumbClick}
        />
    );
};
